import { Component, OnInit } from '@angular/core';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.less']
})
export class BillingHistoryComponent implements OnInit {
  billHistory;
  env = environment;
  private isLoading = false;
  private offset = 0;
  private count = 20;
  displayedColumns = ['date', 'title', 'method', 'period', 'price'];
  constructor(private subscriberService: SubscriberService) { }

  ngOnInit(): void {
    this.billHistory = new Array();
    this.isLoading = false;
    this.offset = 0;
    this.getBillingHistory();
  }

  getBillingHistory() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.subscriberService.getBillingHistory({
      offset: this.offset,
      count: this.count
    }).then((resp: any) => {
      this.billHistory = this.billHistory && this.billHistory.length ? this.billHistory.concat(resp.billHistory) : resp.billHistory;
      this.isLoading = !resp.nextPage;
      this.offset += this.count
    });
  }
}
